export default "__VITE_ASSET__CZib6OGm__"